<template>
  <swiper :options="swiperOptions">
    <swiper-slide class="slide" v-for="item in itemList" :key="item.url">
      <v-card class="slide-content">
        <div class="iframe-wrapper">
          <iframe class="video" :src="item.url" frameborder="0"></iframe>
        </div>
        <v-divider style="margin: 10px 0"></v-divider>
        <div>
          <h5>{{ item.content }}</h5>
        </div>
      </v-card>
    </swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
    <div class="swiper-button-prev" slot="button-prev"></div>
    <div class="swiper-button-next" slot="button-next"></div>
  </swiper>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  data() {
    return {
      windowSize: {
        x: 0,
        y: 0
      },
      itemList: [
        {
          title: "튜토리얼",
          content: "리치고로 알아보는 아파트 시가총액",
          url: "https://www.youtube.com/embed/xTU3N8RuDbE"
        },
        {
          title: "튜토리얼",
          content: "리치고로 알아보는 아파트 시가총액",
          url: "https://www.youtube.com/embed/PZ2Kl5LEwgc"
        },
        {
          title: "튜토리얼",
          content: "리치고로 알아보는 아파트 단지 가격분석 추이",
          url: "https://www.youtube.com/embed/xS7HBCJL3f0"
        },
        {
          title: "튜토리얼",
          content: "리치고로 알아보는 아파트 단지분석 종합 시세표",
          url: "https://www.youtube.com/embed/yr91RCIirfA"
        },
        {
          title: "튜토리얼",
          content: "리치고로 알아보는 아파트 전세가율 추이",
          url: "https://www.youtube.com/embed/ja_ySufRHNQ"
        },
        {
          title: "리치고 꿀팁",
          content:
            "빅데이터 시스템 리치고가 말하는 부동산, 언제 어디가 좋을까?",
          url: "https://www.youtube.com/embed/bXuzl03gqHs"
        }
      ],
      swiperOptions: {
        slidesPerView: window.innerWidth > 800 ? 3 : 1,
        autoplay: true,
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  components: {
    swiper,
    swiperSlide
  }
};
</script>

<style scoped>
.slide-content {
  margin: 10px auto;
  padding: 10px;
  max-width: 1000px;
}
.iframe-wrapper {
  position: relative;
  height: 0;
  padding-bottom: 75%;
}

iframe {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
</style>
